module.exports = __webpack_public_path__ + "static/media/fit_app.9feb8aca.png";